// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./lib/tooltips"
import "./lib/dropdown_dismiss"
import "./lib/cornerstone"
import "./lib/cs_submit_guard"
import "./lib/activity_feed_refresh"

// PWA: capture the browser's install prompt so a UI control can offer it later.
window.fdDeferredInstallPrompt = null
window.addEventListener("beforeinstallprompt", (event) => {
  event.preventDefault()
  window.fdDeferredInstallPrompt = event
  window.dispatchEvent(new Event("fd:installable"))
})
window.addEventListener("appinstalled", () => {
  window.fdDeferredInstallPrompt = null
})

// PWA: register the service worker for offline support + asset caching.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { updateViaCache: "none" })
      .catch((error) => console.warn("Service worker registration failed:", error))
  })
}
